import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { sendServerRequest } from '../../server/request';
import { URLS } from '../../env/urls';
import { openGlobalSnack } from '../utils/snack';

type ReconsultType = 'clt' | 'fgts';

/**
 * Botão (para o menu do chat) que reconsulta a margem. Não reimplementa regra
 * nenhuma: chama o endpoint que aciona a função central de cada script
 * (CLT: cltConsultMarginWithClient / FGTS: fgtsReconsultMargin), que seguem
 * todas as regras. O backend ainda trava por script (CLT só script2, FGTS só
 * script1); aqui o botão só aparece no script certo.
 */
export function ReconsultMargin({ chatId, type }: { chatId: number; type: ReconsultType }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const label = type === 'clt' ? 'Reconsultar margem CLT' : 'Reconsultar margem FGTS';
  const what = type === 'clt' ? 'consulta de margem CLT' : 'consulta de saldo FGTS';

  return (
    <>
      <Button fullWidth variant="text" onClick={() => setOpen(true)}>{label}</Button>
      <Dialog open={open} onClose={() => !loading && setOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{label}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Isto envia uma nova {what} seguindo todas as regras
            (ordem de providers, faixa etária, horário e limites). Deseja continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={() => setOpen(false)}>Cancelar</Button>
          <LoadingButton loading={loading} variant="contained" onClick={reconsult}>Reconsultar</LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );

  function reconsult() {
    setLoading(true);
    sendServerRequest('POST', URLS.fgtsChat.reconsultMargin, { chatId, type }).then((e) => {
      setLoading(false);
      setOpen(false);
      const data = e.data?.data || {};
      const message = data.message || 'Reconsulta processada.';
      openGlobalSnack(message, data.ok ? 'success' : 'warning');
    }).catch((err) => {
      setLoading(false);
      const message = err?.target?.responseText ? safeMessage(err.target.responseText) : '';
      openGlobalSnack(message || 'Não foi possível reconsultar a margem.', 'error');
    });
  }
}

/** Extrai a mensagem de erro do JSONResponse ({ error }) quando vier. */
function safeMessage(responseText: string): string {
  try {
    const json = JSON.parse(responseText);
    return typeof json?.error === 'string' ? json.error : '';
  } catch {
    return '';
  }
}
